




























































import { ATMAsset, TradeSide } from "@/../api/src/models/market";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class PriceImpactModal extends Vue {
  @Prop() offerAsset!: ATMAsset | null;

  @Prop() wantedAsset!: ATMAsset | null;

  @Prop() offerAmount!: string;

  @Prop() pair;

  @Prop() side;

  dialog = false;

  counter = 0;

  timer: any = null;

  filledAvgPrice = 0;

  marketPrice = 0;

  get meta() {
    const getAssetById = this.$store.getters["wallet/mixin/getAssetById"];
    const toPrecision = this.$common.utils.number.toPrecision;

    const {
      filledAvgPrice,
      marketPrice,
      offerAmount,
      offerAsset,
      wantedAsset
    } = this;

    let filledAmount = +offerAmount * +filledAvgPrice;
    if (this.side === TradeSide.BID) {
      filledAmount = +offerAmount / +filledAvgPrice;
    }

    const offerAssetPrice = getAssetById(offerAsset?.asset_id)?.price_usd ?? 0;
    const wantedAssetPrice =
      getAssetById(wantedAsset?.asset_id)?.price_usd ?? 0;
    const offerAmountUsd = +offerAssetPrice * +offerAmount;
    const filledAmountUsd = +wantedAssetPrice * +filledAmount;
    const offerAmountFiat = this.$common.utils.currency.fiat(this, {
      value: offerAmountUsd,
      from: "USD"
    });
    const wantedAmountFiat = this.$common.utils.currency.fiat(this, {
      value: filledAmountUsd,
      from: "USD"
    });
    const impact = Math.abs((filledAvgPrice - marketPrice) / marketPrice) * -1;
    const impactText = this.$common.utils.number.toPercent(impact, false);

    let displayMarketPrice = "" + marketPrice;
    let displayFilledPrice = "" + filledAvgPrice;
    if (this.side === TradeSide.BID) {
      displayMarketPrice = "" + toPrecision(1 / +marketPrice, 8);
      displayFilledPrice = "" + toPrecision(1 / +filledAvgPrice, 8);
    }

    return {
      displayMarketPrice,
      displayFilledPrice,
      impact,
      impactText,
      offerAmountFiat,
      wantedAmountFiat,
      symbol: `${offerAsset?.symbol}/${wantedAsset?.symbol}`,
      offerText: `${this.offerAmount} ${this.offerAsset?.symbol}`,
      filledText: `${filledAmount} ${this.wantedAsset?.symbol}`
    };
  }

  get validated() {
    return this.counter === 0;
  }

  show({ marketPrice, filledAvgPrice }) {
    this.dialog = true;
    this.marketPrice = marketPrice;
    this.filledAvgPrice = filledAvgPrice;

    this.counter = Math.round((1000 * Math.abs(this.meta.impact)) / 2);
    this.startCountDown();
  }

  startCountDown() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.decreaseCounter();
  }

  decreaseCounter() {
    if (this.counter === 0) {
      return;
    }
    this.timer = setTimeout(() => {
      this.counter -= 1;
      this.decreaseCounter();
    }, 1000);
  }

  handleConfirm() {
    this.dialog = false;
    this.$emit("confirm");
  }
}
export default PriceImpactModal;
